module.exports = __webpack_public_path__ + "static/media/food-court-bakery2.2d9dbd0d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/structures/food-court-bakery2.png
// module id = 155
// module chunks = 0